import Swiper from 'swiper/swiper-bundle';
import {gsap} from 'gsap';

class PageNewsPodcastNetwork {
    /**
     * Constructor for PageNewsPodcastNetwork class.
     * @param {string} selector - The selector for the podcast slider.
     */
    constructor(selector = '.podcast-slider') {
        this.selector = selector;
        this.swiperContainer = document.querySelector(this.selector);

        // Initialize Swiper with responsive settings
        this.swiper = new Swiper(this.selector, {
            slidesPerView: 'auto',
            loop: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                },
                1280: {
                    spaceBetween: 40,
                },
            },
        });

        // Autoscroll speed setting
        this.autoScrollSpeed = 40;
        // Track if the mouse is over the Swiper container
        this.mouseOver = false;
        // Track if the user is dragging a slide
        this.isDragging = false;

        this.init();
        this.runAutoScroll();
    }

    /**
     * Initialize event listeners for mouse interactions and Swiper events.
     */
    init() {
        this.swiperContainer.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.swiperContainer.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        this.swiperContainer.addEventListener('touchstart', this.handleTouchStart.bind(this));
        this.swiperContainer.addEventListener('touchend', this.handleTouchEnd.bind(this));
        this.swiperContainer.addEventListener('click', this.handleClick.bind(this));  // New click event
        this.swiper.on('touchStart', this.handleTouchStart.bind(this));
        this.swiper.on('dragStart', this.handleDragStart.bind(this));
        this.swiper.on('slideChangeTransitionEnd', this.handleSlideChangeEnd.bind(this));
    }

    /**
     * Handle touch start event (for touch devices).
     */
    handleTouchStart() {
        this.isDragging = true;
        gsap.killTweensOf(this.swiper);
    }

    /**
     * Handle touch end event (for touch devices).
     */
    handleTouchEnd() {
        this.isDragging = false;
        if (!this.mouseOver) {
            this.runAutoScroll();
        }
    }

    /**
     * Handle drag start event.
     */
    handleDragStart() {
        this.isDragging = true;
    }

    /**
     * Handle the end of slide change transition.
     */
    handleSlideChangeEnd() {
        this.isDragging = false;
        if (!this.mouseOver) {
            clearTimeout(this.timeOut);
            this.timeOut = setTimeout(this.runAutoScroll.bind(this), 500);
        }
    }

    /**
     * Run the autoscroll animation on the Swiper instance.
     */
    runAutoScroll() {
        gsap.killTweensOf(this.swiper);
        gsap.to(this.swiper, {
            progress: 1,
            duration: this.autoScrollSpeed,
            ease: 'none',
            repeat: -1,
            onUpdate: () => {
                let progress = gsap.getProperty(this.swiper, "progress");
                this.swiper.setTranslate(this.swiper.maxTranslate() * progress);
            }
        });
    }

    /**
     * Event handler for when the mouse enters the Swiper container.
     */
    onMouseEnter() {
        this.mouseOver = true;
        gsap.killTweensOf(this.swiper);
    }

    /**
     * Event handler for when the mouse leaves the Swiper container.
     */
    onMouseLeave() {
        this.mouseOver = false;
        if (!this.isDragging) {
            this.runAutoScroll();
        }
    }

    /**
     * Handle click event.
     */
    handleClick() {
        this.mouseOver = false;
        this.isDragging = false;
        this.onMouseLeave();
    }
}

export default PageNewsPodcastNetwork;
